/**
 * SalesServices — wrapper compatível com chamadas legadas.
 * Antes: GET /sale/owner (V1, quebrada no schema V2)
 * Agora: GET /api/v2/sales/me (agregado V2)
 *
 * Mantém shape { success, data: [...] } pra UI não precisar mudar.
 */

import { salesV2API } from '../v2/sales';

const SalesServices = {
  /**
   * Vendas do owner autenticado.
   * Aceita opcionalmente params { limit, offset, status }.
   */
  getMySales: async (params = {}) => {
    try {
      const res = await salesV2API.listMine(params);
      return {
        success: true,
        data: res.data?.sales || res.data?.data || [],
        pagination: res.data?.pagination || null,
      };
    } catch (error) {
      console.error('Error in getMySales:', error);
      throw error;
    }
  },
};

export default SalesServices;
